import { render, staticRenderFns } from "./tab1content.vue?vue&type=template&id=c303fe96&scoped=true&"
import script from "./tab1content.vue?vue&type=script&lang=js&"
export * from "./tab1content.vue?vue&type=script&lang=js&"
import style0 from "./tab1content.vue?vue&type=style&index=0&id=c303fe96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c303fe96",
  null
  
)

export default component.exports